import React from "react";
import { Link } from "react-router-dom";

const BelowMain = () => {
  return (
    <div>
      <div className="container-fluid ps-5 mt-2">
        <div className="row">
          <div className="col-md-5 margin_investing_for_everyone" data-aos="fade-up">
            <div className="pt-5 font_and_style ">
              <div className="margin_button_text_belwo_head">INVESTING</div>
              <div className="margin_button_text_belwo_head flurentpink">
                FOR
              </div>
              <div className="margin_button_text_belwo_head">EVERYONE'S</div>
              <div className="margin_button_text_belwo_head">NEED</div>
            </div>
          </div>
          <div className="col-md-7">
            <div className="h-50 d-flex   align-items-center ">
              <div className="bg-black p-3 post_abslotue rounded-4 ms-5 padding_box_balck_one box_pruplr_heigh_and_white" data-aos="fade-right">
                <div className="d-flex justify-content-end fs-4 mb-5 flurentpink">02</div>
                <div className="row">
                  <div className="col-md-9">
                    <div className="d-flex justify-content-start mb-2 text-white  ">
                    "Splits money proportionally between two people."
                    </div>
                  </div>
                  <div className="col-md-3 d_flex_stuff_for_arrow ">
                    <Link to="/investone" className=" rounded_gree_button_circle   d-flex justify-content-center align-items-center">
                      <i class="fa-solid fa-arrow-right text-black fs-5 "></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-50 d-flex justify-content-center  align-items-center " >
              <div data-aos="fade-right" className="bg-black p-3 postion_two_abs rounded-4 box_pruplr_heigh_and_white margin_left_k">
                <div className="d-flex justify-content-end fs-4 mb-5 flurentpink">03</div>
                <div className="row">
                  <div className="col-md-9">
                    <div className="d-flex justify-content-start mb-2 text-white ">
                    "Distributes money by percentage to multiple users."  
                    </div>
                  </div>
                  <div className="col-md-3  d_flex_stuff_for_arrow">
                    <Link to="/investtwo" className=" rounded_gree_button_circle d-flex justify-content-center align-items-center">
                      <i class="fa-solid fa-arrow-right text-black fs-5 "></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BelowMain;
